/**
 * Created by Ram on 10/05/2017.
 */

import React, { Component } from "react";
import CompletedTestInstanceList from "../presentation/CompletedTestInstance/CompletedTestInstanceList";

class CompletedTestInstanceListWidget extends Component {
  constructor(props) {
    super(props);

    const resultsPerPage = 10;
    this.isUnmounted = false;

    this.state = {
      isLoading: true,
      testInstances: [],
      search: "",
      sort: "endTime",
      sortAsc: false,
      currentPageNumber: 1,
      skip: 0,
      testInstance: "",
      devices: [],
      scenarioName: "",
      scenarioEnvironment: "",
      sortDevices: "name",
      sortDevicesAsc: true,
      error: "",
      serverError: "",
      showValidOnly: localStorage.getItem("showValidOnly") === "true",
      hideCancelled: localStorage.getItem("hideCancelled") === "true",
      success: "",
      totalPages: "",
      resultsPerPage: resultsPerPage,
      editingPageNumber: false,
      pageNumberTemp: 0,
      isEditingCommentsBox: false,
      compareSelection: [],
      savedComparisons: []
    };
  }

  componentDidMount() {
    this.handleAddStatusFields(() => {
      this.getTestInstanceList();
    });
    this.loadSavedComparisons();
  }

  getTestInstanceUrl = () =>
    "/service/testInstancesPagination?search=" +
    this.state.search +
    "&sort=" +
    this.state.sort +
    "&sortAsc=" +
    this.state.sortAsc +
    "&skip=" +
    this.state.skip +
    "&showValidOnly=" +
    this.state.showValidOnly +
    "&hideCancelled=" +
    this.state.hideCancelled;

  getTestInstanceList(testInstanceIdSelect = null) {
    let searchLocal = this.getTestInstanceUrl();

    this.setState({ isLoading: true, testInstances: [] }, () => {
      fetch(searchLocal, {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json"
        },
        credentials: "same-origin"
      }).then(response => {
        if (response.status !== 200) {
          this.setState({
            error: "An error has occurred fetching test instance details",
            isLoading: false
          });
        } else {
          if (!this.isUnmounted) {
            response.json().then(totalResults => {
              this.setState(prevState => ({
                totalPages: Math.ceil(
                  totalResults.totalRecords / prevState.resultsPerPage
                ),
                isLoading: false
              }));

              let testInstances = totalResults.results;

              if (testInstances.length) {
                //If an instance is to be selected, select it, otherwise select the first instance on the page
                if (testInstanceIdSelect) {
                  this.getSingleTestInstance(testInstanceIdSelect);
                } else {
                  this.getSingleTestInstance(testInstances[0]._id);
                }
                this.setState({ testInstances });
              } else {
                this.setState({
                  testInstances: [],
                  currentPageNumber: 1,
                  totalPages: 1
                });
              }
            });
          }
        }
      });
    });
  }

  enableEditPageNumber = () => {
    this.setState(prevState => ({
      editingPageNumber: true,
      pageNumberTemp: prevState.currentPageNumber
    }));
  };

  saveEditPageNumber = e => {
    let keyCode = e.keyCode || e.which;
    const KEYCODE_ENTER = 13;
    if (keyCode === KEYCODE_ENTER && this.state.pageNumberTemp !== "") {
      let currentPageNumber = this.state.pageNumberTemp;
      let skip = (currentPageNumber - 1) * this.state.resultsPerPage;
      this.setState(
        {
          editingPageNumber: false,
          currentPageNumber: currentPageNumber,
          skip: skip
        },
        () => { this.getTestInstanceList() }
      );
      return false;
    }
  };


  updateEditCommentsBoxValue = e => {
    let { value } = e.target;
    this.setState(prevState => {
      const { testInstance } = prevState;

      testInstance.comments = value;

      return { testInstance };
    });
  };

  editPageNumberState = e => {
    let value = Number(e.target.value);
    if (value >= 1 && value <= this.state.totalPages) {
      this.setState({ pageNumberTemp: value });
    } else if (e.target.value === "") {
      this.setState({ pageNumberTemp: "" });
    }
  };

  updateSortState = sortBy => {
    if (sortBy === this.state.sort) {
      this.setState(
        prevState => ({
          sortAsc: !prevState.sortAsc,
          currentPageNumber: 1,
          skip: 0,
          testInstances: []
        }),
        this.getTestInstanceList
      );
    } else {
      this.setState({ sort: sortBy }, this.getTestInstanceList);
    }
  };

  updateSearchState = e => {
    this.setState(
      {
        search: e.target.value,
        currentPageNumber: 1,
        skip: 0
      },
      this.getTestInstanceList
    );
  };

  handleFirst = () => {
    this.setState(
      {
        skip: 0,
        currentPageNumber: 1,
        editingPageNumber: false
      },
      this.getTestInstanceList
    );
  };

  deleteTestInstance = testInstanceId => {
    if (confirm('Are you sure you want to delete this test instance?')) {
        fetch('/service/deleteTestInstance', {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
            credentials: 'same-origin',
            body: JSON.stringify({ testInstanceId: testInstanceId }),
        }).then(response => {
            if (response.status === 200) {
                this.getTestInstanceList();
            }else{
                alert("Failed to delete test instance. It may be in progress or already deleted.")
            }
        });
      }
  };

  handlePrevious = () => {
    let currentPageNumber = this.state.currentPageNumber;
    if (currentPageNumber > 1) {
      let skip = (currentPageNumber - 2) * this.state.resultsPerPage;
      this.setState(
        {
          skip: skip,
          currentPageNumber: currentPageNumber - 1,
          editingPageNumber: false
        },
        this.getTestInstanceList
      );
    }
  };

  handleNext = () => {
    let currentPageNumber = this.state.currentPageNumber;
    if (currentPageNumber < this.state.totalPages) {
      let skip = currentPageNumber * this.state.resultsPerPage;
      this.setState(
        {
          skip: skip,
          currentPageNumber: currentPageNumber + 1,
          editingPageNumber: false
        },
        this.getTestInstanceList
      );
    }
  };

  handleLast = () => {
    const { totalPages, resultsPerPage } = { ...this.state };
    const skip = (totalPages - 1) * resultsPerPage;
    this.setState(
      prevState => ({
        skip: skip,
        currentPageNumber: prevState.totalPages,
        editingPageNumber: false
      }),
      this.getTestInstanceList
    );
  };

  handleToggleShowValidOnly = () => {
    this.setState(prevState => {
      localStorage.setItem("showValidOnly", String(!prevState.showValidOnly));
      return { showValidOnly: !prevState.showValidOnly };
    }, this.getTestInstanceList);
  };

  handleToggleHideCancelled = () => {
    this.setState(prevState => {
      localStorage.setItem("hideCancelled", String(!prevState.hideCancelled));
      return { hideCancelled: !prevState.hideCancelled };
    }, this.getTestInstanceList);
  };

  handleAddStatusFields = callback => {
    fetch("/service/updateStatusFields?addOnly=true", {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json"
      },
      credentials: "same-origin"
    }).then(response => {
      if (response.status !== 200) {
      } else {
        callback();
      }
    });
  };

  getSingleTestInstance = testInstanceId => {
    fetch(
      "/service/getSingleTestInstanceDetails?testInstanceId=" + testInstanceId,
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json"
        },
        credentials: "same-origin"
      }
    ).then(response => {
      if (response.status !== 200) {
        this.setState({
          error: "An error has occurred fetching single test instance details"
        });
      } else if (!this.isUnmounted) {
        response.json().then(testInstance => {
          this.setState({ testInstance });
          this.getScenarioDetails(testInstance);
          this.getTestInstanceDevices(testInstance);
        });
      }
    });
  };


  getScenarioDetails = testInstance => {
    let scenarioId = testInstance.scenarioId;

    if (scenarioId !== null && scenarioId !== "") {
      fetch("/service/getScenarioDetails?scenarioId=" + scenarioId, {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json"
        },
        credentials: "same-origin"
      }).then(response => {
        if (response.status === 200) {
          response.json().then(json => {
            if (json && !this.isUnmounted) {
              this.setState({
                scenarioName: json.name,
                scenarioEnvironment: json.environment
              });
            }
          });
        }
      });
    } else {
      this.setState({ scenarioName: "", scenarioEnvironment: "" });
    }
  };

  getTestInstanceDevices = testInstance => {
    let devices = [];
    testInstance.devices.map(testDevice => {
      devices.push(testDevice.deviceId);
    });

    this.setState({ currentInstance: testInstance });

    fetch(
      "/service/getClusterDevices?devices=" +
        devices +
        "&sortDevices=" +
        this.state.sortDevices +
        "&sortDevicesAsc=" +
        this.state.sortDevicesAsc,
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json"
        },
        credentials: "same-origin"
      }
    ).then(response => {
      if (response.status === 200 && !this.isUnmounted) {
        response.json().then(devices => {
          this.setState({ devices });
        });
      }
    });
  };

  saveComments = (comments) => {
    const body = {
      comments: comments,
      testInstanceId: this.state.testInstance._id
    };

    this.setState({ serverError: "", success: "" });

    fetch("/service/editTestInstanceComments", {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json"
      },
      credentials: "same-origin",
      body: JSON.stringify(body)
    }).then(response => {
      if (response.status === 200) {
        console.log("Comments saved successfully.");
      } else {
        console.log("Error saving comments: response code " + response.status);
      }
    });
  };

  toggleValid = testInstanceId => {
    let body = {
      testInstanceId: testInstanceId
    };

    fetch("/service/toggleValidTestInstance", {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json"
      },
      credentials: "same-origin",
      body: JSON.stringify(body)
    }).then(response => {
      if (response.status === 200) {
        response.json().then(json => {
          //Reload test instance list, selecting the just-modified instance
          this.getTestInstanceList(testInstanceId);
        });
      }
    });
  };

  updateFormState = e => {
    let obj = {};
    obj[e.target.name] = e.target.value;
    this.setState(obj);
  };

  updateDevicesSortState = sortBy => {
    this.setState(
      prevState => {
        if (sortBy === prevState.sortDevices) {
          return { sortDevicesAsc: !this.state.sortDevicesAsc };
        } else {
          return { sortDevices: sortBy };
        }
      },
      () => this.getTestInstanceDevices(this.state.currentInstance)
    );
  };

  goToStats = testInstanceId => {
    let queryParameterString =
      "?page=" +
      this.state.currentPageNumber +
      "&sort=" +
      this.state.sort +
      "&sortOrder=" +
      (this.state.sortAsc ? "asc" : "desc") +
      "&id=" +
      this.state.testInstance._id;
    this.props.navigator.requestAnalytics(testInstanceId, queryParameterString);
    this.isUnmounted = true;
  };

  goToClone = testInstanceId => {
    this.props.navigator.requestAddNewTestInstance(testInstanceId);
    this.isUnmounted = true;
  };

  toggleCompareSelection = testInstanceId => {
    this.setState(prevState => {
      const isSelected = prevState.compareSelection.includes(testInstanceId);
      return {
        compareSelection: isSelected
          ? prevState.compareSelection.filter(id => id !== testInstanceId)
          : [...prevState.compareSelection, testInstanceId]
      };
    });
  };

  clearCompareSelection = () => {
    this.setState({ compareSelection: [] });
  };

  goToCompare = () => {
    if (this.state.compareSelection.length < 2) {
      return;
    }
    this.props.navigator.requestCompareTestInstances(this.state.compareSelection);
    this.isUnmounted = true;
  };

  // Load the list of saved comparisons so they can be reopened (BD-8222).
  loadSavedComparisons = () => {
    fetch("/service/savedComparisons", {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json"
      },
      credentials: "same-origin"
    }).then(response => {
      if (response.status === 200 && !this.isUnmounted) {
        response.json().then(savedComparisons => {
          this.setState({ savedComparisons: Array.isArray(savedComparisons) ? savedComparisons : [] });
        });
      }
    });
  };

  // Reopen a saved comparison, restoring its instances and view settings (BD-8222).
  openSavedComparison = comparison => {
    if (!comparison || !Array.isArray(comparison.testInstanceIds) || comparison.testInstanceIds.length < 2) {
      return;
    }
    this.props.navigator.requestCompareTestInstances(comparison.testInstanceIds, {
      initialGroupBy: comparison.groupBy,
      initialSdkFilter: comparison.sdkFilter,
      savedComparisonId: comparison._id,
      savedComparisonName: comparison.name
    });
    this.isUnmounted = true;
  };

  deleteSavedComparison = comparisonId => {
    if (!confirm("Delete this saved comparison?")) {
      return;
    }
    fetch("/service/deleteComparison", {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json"
      },
      credentials: "same-origin",
      body: JSON.stringify({ comparisonId })
    }).then(response => {
      if (response.status === 200) {
        this.loadSavedComparisons();
      }
    });
  };

  render() {
    return (
      <CompletedTestInstanceList
        navigator={this.props.navigator}
        loadData={this.state}
        enableEditPageNumber={this.enableEditPageNumber}
        editPageNumberState={this.editPageNumberState}
        saveEditPageNumber={this.saveEditPageNumber}
        updateSearchState={this.updateSearchState}
        updateSortState={this.updateSortState}
        updateFormState={this.updateFormState}
        handleFirst={this.handleFirst}
        handlePrevious={this.handlePrevious}
        handleNext={this.handleNext}
        handleLast={this.handleLast}
        handleToggleShowValidOnly={this.handleToggleShowValidOnly}
        handleToggleHideCancelled={this.handleToggleHideCancelled}
        getSingleTestInstance={this.getSingleTestInstance}
        saveComments={this.saveComments}
        toggleValid={this.toggleValid}
        updateDevicesSortState={this.updateDevicesSortState}
        goToStats={this.goToStats}
        goToClone={this.goToClone}
        updateEditCommentsBoxValue={this.updateEditCommentsBoxValue}
        deleteTestInstance={this.deleteTestInstance}
        toggleCompareSelection={this.toggleCompareSelection}
        clearCompareSelection={this.clearCompareSelection}
        goToCompare={this.goToCompare}
        openSavedComparison={this.openSavedComparison}
        deleteSavedComparison={this.deleteSavedComparison}
      />
    ); //return
  } //render
} //CompletedTestInstanceListWidget

export default CompletedTestInstanceListWidget;
